import { createStyles } from '@mantine/styles';

var useIconStyle = createStyles(function (_, _ref) {
  var size = _ref.size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'inherit' : _ref$color;
  return {
    root: {
      display: 'inline-flex',
      color: color,
      width: "".concat(size, "px"),
      minWidth: "".concat(size, "px"),
      height: "".concat(size, "px"),
      minHeight: "".concat(size, "px"),
      position: 'relative',
      lineHeight: 1,
      '&.iconfont': {
        fontSize: "".concat(size, "px")
      },
      '& > svg': {
        width: '100%',
        height: '100%'
      }
    }
  };
});

export { useIconStyle as default };
//# sourceMappingURL=Icon.style.js.map
